import context from '../context';

export default function canSeeUserShifts(user) {
  if (context.me.isAdmin || user.id === context.me.id) {
    return true;
  }

  const locationIds = user.locationIds || [];
  const positionIds = user.positionIds || [];

  if (context.me.isManager) {
    return (
      context.managersCanSeeSchedulesInOtherLocations ||
      locationIds.some((id) => context.me.locationIds.includes(id))
    );
  }

  let canSeeUser = true;
  if (!context.usersCanSeeSchedulesInOtherLocations) {
    canSeeUser = canSeeUser && locationIds.some((id) => context.me.locationIds.includes(id));
  }

  if (!context.usersCanSeeSchedulesForOtherPositions) {
    canSeeUser = canSeeUser && positionIds.some((id) => context.me.positionIds.includes(id));
  }

  return canSeeUser;
}
